import { useEffect, useRef } from 'react';

import { exportToSvg, MIME_TYPES, serializeLibraryAsJSON } from '@excalidraw/excalidraw';
import { BinaryFiles, LibraryItem } from '@excalidraw/excalidraw/types/types';

type Props = {
    libraryItem: LibraryItem,
    files: BinaryFiles | null
};

export default function DraggableLibraryItem(props: Props) {
    const ref = useRef<HTMLDivElement | null>(null);

    const { libraryItem } = props;

    useEffect(() => {
        const appState = { exportBackground: false };
        let svg: SVGSVGElement;
        const { current } = ref;
        const { files } = props;

        const { elements } = libraryItem;

        if (!current) {
            return;
        }

        (async () => {
            svg = await exportToSvg({ elements, appState, files });
            // eslint-disable-next-line
            for (const child of current.children) {
                if (child.tagName !== 'svg') {
                    // eslint-disable-next-line
                    continue;
                }
                current.removeChild(child);
            }
            current.appendChild(svg);
        })();

        return () => {
            if (svg) {
                current.removeChild(svg);
            }
        };
    }, [libraryItem, props]);

    return (
        <div
            ref={ref}
            style={{ width: '2.5rem', height: '2.5rem', backgroundColor: '#e0e0e0', padding: '0.25rem', borderRadius: 5 }}
            draggable={true}
            onDragStart={(event) => event.dataTransfer.setData(
                MIME_TYPES.excalidrawlib,
                serializeLibraryAsJSON([libraryItem])
            )}
        >

        </div>
    );
}
